<template>
<div class="page-wrapper">
	<div class="page page-settings">
		<div class="container">
			<div class="page-header">
				<h1 class="page-title">
					<router-link class="text" to="/settings">Settings</router-link>
					<i class="separator material-icons">chevron_right</i>
					<span class="page-breadcrumb">Tracking</span>
				</h1>
			</div>
			<div class="page-content">
				<div class="p-3 text-center" v-if="isFetching">
					<div class="is-loading large"></div>
				</div>
				<template v-if="!isFetching">
					<div class="integration-item box p-0">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<img src="/images/logo-small-facebook.png" alt="Facebook">
								</div>
								<button type="button" class="integration-app-button btn btn-primary" @click="toggleModal('add')" v-if="isFBTrackingEmpty">+ Add Facebook Server-Side Tracking</button>
							</div>
						</div>
						<integration-accounts
							:editable="true"
							:name="'Tracking'"
							:accounts="fbTracking"
							@edit="editFbTracking"
							@remove="removeIntegration">
							<template slot-scope="slotProps">
								{{ slotProps.account.account_name }} <span v-bind:class="{ 'integration-status error': !slotProps.account.is_active }">{{ isActiveLabel(slotProps.account.is_active) }}</span>
							</template>
						</integration-accounts>
					</div>
				</template>
			</div>
		</div>
	</div>
	<div class="modals">
		<!-- Facebook -->
		<modal class="integration-modal" :size="'large'" v-if="isShowModalFb" @close="isShowModalFb = false">
			<div slot="header"><h3>Facebook</h3></div>
			<div slot="body" class="text-center row">
				<!-- TUTORIAL -->
				<div class="col-md-6">
					<h4 class="modal-title">How to Integrate</h4>
					<div class="integration-video embed-responsive embed-responsive-16by9">
						<iframe src="https://www.youtube.com/embed/sPwDAFjxs6I?rel=0"></iframe>
					</div>
				</div>
				<!-- CONFIG -->
				<div class="col-md-6">
					<h4 class="modal-title">Configurations</h4>
					<div class="integration-actions">
						<!-- access token -->
						<div class="form-group text-left">
							<label><b>Access Token</b></label>
							<input type="text" class="input form-control" placeholder="Access Token" v-model="accessToken">
						</div>

						<!-- trigger condition -->
						<div class="form-group text-left">
							<label><b>Trigger Condition</b></label>
							<multiselect
								v-model="triggerCondition"
								placeholder="Trigger Condition"
								label="label"
								track-by="value"
								:searchable="false"
								:options="triggerConditionOptions"
								:show-labels="false"
								:preselect-first="false"
								:allow-empty="false">
								<span slot="noResult">Not found</span>
							</multiselect>
						</div>

						<!-- event name -->
						<div class="form-group text-left">
							<label><b>Event Name</b></label>
							<input type="text" class="input form-control" placeholder="Event Name" v-model="eventName">
						</div>

						<!-- event value -->
						<div class="form-group text-left">
							<label><b>Event Value</b></label>
							<multiselect
								v-model="eventValue"
								placeholder="Trigger Condition"
								label="label"
								track-by="value"
								:searchable="false"
								:options="eventValueOptions"
								:show-labels="false"
								:preselect-first="false"
								:allow-empty="false">
								<span slot="noResult">Not found</span>
							</multiselect>
						</div>

						<!-- action -->
						<div class="text-right">
							<button
								v-if="modalType === 'add'"
								type="button"
								class="btn btn-primary"
								:class="{ 'is-loading': isAdding }"
								:disabled="accessToken.length === 0"
								@click="addFacebookTracking">Add
							</button>
							<button
								v-else-if="modalType === 'edit'"
								type="button"
								class="btn btn-primary"
								:class="{ 'is-loading': isAdding }"
								:disabled="accessToken.length === 0"
								@click="updateFacebookTracking">Update
							</button>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-light" @click="isShowModalFb = false">{{ $t('Close') }}</button>
			</div>
		</modal>

	</div>

	<notifications group="tracking" position="bottom right" />
</div>
</template>

<script>
// /* eslint-disable */
import { mapGetters, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';
import Modal from '../components/Modal.vue';
import IntegrationAccounts from '../components/IntegrationAccounts.vue';
import integrationApi from '../api/integration';

const triggerConditionOptions = [
	{
		label: 'When order status is Processing',
		value: 'processing',
	},
	{
		label: 'When order status is Completed',
		value: 'completed',
	},
	{
		label: 'When order payment status is Paid',
		value: 'paid',
	},
];

const eventValueOptions = [
	{
		label: 'Total Price',
		value: 'total_price',
	},
	{
		label: 'Product Price',
		value: 'total_product_price',
	},
];

export default {
	name: 'settingsTracking',
	components: {
		Modal,
		IntegrationAccounts,
		Multiselect,
	},
	data() {
		return {
			isShowModalFb: false,
			isAdding: false,
			modalType: 'add',
			accessToken: '',
			triggerConditionOptions,
			eventValueOptions,
			triggerCondition: triggerConditionOptions[0],
			eventName: 'Purchase',
			eventValue: eventValueOptions[0],
			integrationId: '',
		};
	},
	methods: {
		...mapActions({
			fetchAccounts: 'settings/fetchAccounts',
			addAccount: 'settings/addAccount',
			updateAccount: 'settings/updateAccount',
			removeAccount: 'settings/removeAccount',
		}),

		toggleModal(type = 'add') {
			this.modalType = type;
			if (type === 'add') {
				this.clearfields();
			}
			this.isShowModalFb = !this.isShowModalFb;
		},

		editFbTracking(id) {
			this.toggleModal('edit');
			this.integrationId = id;
			this.isShowModalFb = true;
			const fbTracking = this.fbTracking.length > 0 ? this.fbTracking[0].data : null;
			const triggerConditionValue = fbTracking && fbTracking.trigger_condition ? fbTracking.trigger_condition : 'processing';
			const triggerCondition = this.triggerConditionOptions.find(curr => curr.value === triggerConditionValue);
			const eventValueString = fbTracking && fbTracking.event_value ? fbTracking.event_value : 'total_price';
			const eventValue = this.eventValueOptions.find(curr => curr.value === eventValueString);
			this.accessToken = fbTracking.access_token;
			this.triggerCondition = triggerCondition;
			this.eventName = fbTracking.event_name;
			this.eventValue = eventValue;
		},

		addFacebookTracking() {
			this.isAdding = true;
			const params = {
				access_token: this.accessToken,
				trigger_condition: this.triggerCondition.value,
				event_name: this.eventName,
				event_value: this.eventValue.value,
			};

			const callback = (response) => {
				const account = response.data;
				const fbTrackingAccount = Object.assign({}, account, params);

				this.isShowModalFb = false;
				this.isAdding = false;

				if (account !== null && account !== '') {
					this.addAccount(fbTrackingAccount);
					this.$notify({
						group: 'tracking',
						title: 'Tracking',
						text: `Successfully , ${response.message}`,
						type: 'success',
					});
				} else {
					this.$notify({
						group: 'tracking',
						title: 'Tracking',
						text: response.message,
						type: 'error',
					});
				}
			};

			integrationApi.addFbTracking(params, callback);
		},

		updateFacebookTracking() {
			this.isAdding = true;
			const id = this.integrationId;
			const params = {
				access_token: this.accessToken,
				trigger_condition: this.triggerCondition.value,
				event_name: this.eventName,
				event_value: this.eventValue.value,
			};

			const callback = (response) => {
				const account = response.data;
				account.is_active = true;

				this.isShowModalFb = false;
				this.isAdding = false;

				if (account !== null && account !== '') {
					this.updateAccount(account);
					this.$notify({
						group: 'tracking',
						title: 'Tracking',
						text: `Successfully , ${response.message}`,
						type: 'success',
					});
				} else {
					this.$notify({
						group: 'tracking',
						title: 'Tracking',
						text: response.message,
						type: 'error',
					});
				}
			};

			integrationApi.updateFbTracking(id, params, callback);
		},

		removeIntegration(id) {
			this.removeAccount(id);
			const callback = () => {
				// console.log(response);
			};
			integrationApi.remove(id, callback);
		},

		isActiveLabel(isActive) {
			const message = isActive ? '' : 'Access token invalid, please reconnect your Facebook Server-Side access token';
			return message;
		},

		clearfields() {
			this.accessToken = '';
			this.eventName = 'Purchase';
			this.triggerCondition = this.triggerConditionOptions[0];
			this.eventValue = this.eventValueOptions[0];
		},

	},
	computed: {
		...mapGetters({
			isFetching: 'settings/isFetching',
			accounts: 'settings/accounts',
		}),
		fbTracking() {
			return this.accounts.filter(account => account.name === 'facebook_server_side_tracking');
		},
		isFBTrackingEmpty() {
			return this.fbTracking.length === 0;
		},

	},
	created() {
		if (!this.isFetching) {
			this.fetchAccounts({ get_details: true });
		}
	},
};
</script>
